import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import { Permission } from '../../../../../common/models/permission.model';
import { HistoryTabComponent } from '../../request-details/history-tab/history-tab.component';
import { SCHEDULE_REQUESTS_FILTER_KEY } from './schedule-requests.constants';

@Component({
  selector: 'lib-schedule-requests',
  imports: [HistoryTabComponent],
  templateUrl: './schedule-requests.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ScheduleRequestsComponent {
  scheduleId = input.required<number>();
  permissions = input.required<Permission[]>();

  scheduleFilter = computed(() => {
    return { [SCHEDULE_REQUESTS_FILTER_KEY]: this.scheduleId().toString() };
  });
}
